import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CmsRouteModule} from "./cms.route";
import {FileComponent} from "./files/file.component";
import {FileListComponent} from "./files/components/file-list/file-list.component";
import {FileUpsertComponent} from "./files/components/file-upsert/file-upsert.component";
import {UtilityModule} from "../utility/utility.module";
import {ReactiveFormsModule} from "@angular/forms";
import {FilePickerComponent} from "./files/components/filepicker/filepicker.component";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

@NgModule({
  providers: [
    {provide: MAT_DIALOG_DATA, useValue: {}},
  ],
  declarations: [
    FileComponent,
    FileListComponent,
    FileUpsertComponent,
    FilePickerComponent
  ],
  exports: [
    FilePickerComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CmsRouteModule,
    UtilityModule
  ]
})
export class CmsModule {
}
